<template>
  <a-modal :visible="visible" @cancel="$emit('cancel')" :footer="null" centered>
    <div>
      <LoginForm @wxlogin="(e) => getWXInfo(e)" />
      <MobileForm />
      <QrcodeForm />
      <BindForm />
    </div>
  </a-modal>
</template>
<script>
import LoginForm from './form.vue';
import MobileForm from './mobile.vue';
import QrcodeForm from './qrcode.vue';
import BindForm from './bind.vue';
export default {
  props: {
    visible: Boolean,
  },
  components: {
    LoginForm,
    MobileForm,
    BindForm,
    QrcodeForm,
  },
};
</script>
